module.exports = __webpack_public_path__ + "img/thumbnail_Moose_j_albino.9a0dcf46.png";